module.exports = __webpack_public_path__ + "img/SINGLE EAR RING RED.9a16788.svg";